import React, { useEffect, useState } from "react";
import DownloadCard from "./DownloadCard";
import { useAuth } from "../../Context/store/context";
import { _showToast } from "../../../toastHelper";
import globals from "../../../globals";
import { useDispatch, useSelector } from "react-redux";
import Pagination from "../../Layout/Pagination";
import { IconSearch, IconX } from "@tabler/icons-react";
import { _get } from "../../../apiClient";

export default function Downloads() {
  const { showLoader, hideLoader, updateTitleAndIcon, getToken, logoutuser } = useAuth();
  const userDetails = useSelector((state) => state.admininfo.admininfo);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState(0);
  const [downloads, setDownloads] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    if (!getToken())
      logoutuser();
    updateTitleAndIcon(globals.downloads.title, globals.downloads.icon);
  }, []);

  useEffect(() => {
    if (userDetails) {
      fetchCategories();
    }
  }, [userDetails]);

  const fetchCategories = async () => {
    showLoader();
    await _get(`/download-categories/all`)
      .then((response) => {
        setCategories(response);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }

  useEffect(() => {
    if (userDetails) {
      fetchDownloads();
    }
  }, [currentPage, searchTerm, category]);

  const fetchDownloads = async () => {
    showLoader();
    await _get(`/downloads?page=${currentPage}&pageSize=20&sortBy=-createdon&searchTerm=${searchTerm}&category=${category}`)
      .then((response) => {
        setDownloads(response.records);
        setCurrentPage(response.currentPage);
        setTotalPages(response.pageCount);
        hideLoader();
      })
      .catch((error) => {
        hideLoader();
        _showToast(error, "error");
      });
  }

  const searchHandler = () => {
    setSearchTerm(searchValue);
    setCurrentPage(0);
  }

  const resetHandler = () => {
    setSearchTerm("");
    setSearchValue("");
    setCurrentPage(0);
  }

  const paginationHandler = (from) => {
    if (from == "previous" && (currentPage - 1) >= 0) {
      setCurrentPage(currentPage - 1);
    }
    else if (from == "next" && (currentPage + 1) <= totalPages) {
      setCurrentPage(currentPage + 1);
    }
  }

  return (
    <div className="content-wrapper">
      <div className="container-xxl flex-grow-1 pt-3">
        <div className="card mb-3 ">
          <div className="card-body d-flex align-items-center flex-wrap">
            <div className="flex-grow-1 d-flex flex-wrap">
              <div className="flex-grow-1 flex-shrink-0 search me-1">
                <div className="search-input-wrap w-100 md-w-75">
                  <input className="search-input w-100 p-2" placeholder="Search by name" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} />
                  {searchValue && searchValue != "" &&
                    <IconX size={16} className="search-clear" onClick={resetHandler} />
                  }
                </div>
                <button className="btn btn-soft-primary search-btn me-1" onClick={searchHandler}><IconSearch size={16} /></button>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {categories && categories.length > 0 && (
            <div className="pt-2 pb-4">
              <ul className="gap-2 d-inline-flex flex-row flex-wrap fw-medium list-unstyled mb-0">
                <li>
                  <button onClick={() => setCategory(0)}
                    className={`category-btn ${category == 0 ? "selected" : ""}`}>
                    All
                  </button>
                </li>
                {categories.map((item) => {
                  return (
                    <li>
                      <button onClick={() => setCategory(item.id)}
                        className={`category-btn ${category == item.id ? "selected" : ""}`}>
                        {item.name}
                      </button>
                    </li>
                  )
                })}
              </ul>
            </div>
          )}
          <div className="col-md-12 pb-5">
            {(!downloads || (downloads && downloads.length == 0)) && (
              <div className="card">
                <div className="card-body mb-5">
                  <div className=" d-flex flex-column align-items-center justify-content-center">
                    <div className="mt-4">
                      <img
                        src="/images/no-events-found.jpg"
                        alt="No Data Found"
                        id="noeventsimg"
                      />
                    </div>
                    <h4 className="mt-4">No Data Found </h4>
                    <div></div>
                  </div>
                </div>
              </div>
            )}

            {downloads && downloads.length > 0 && (
              <>
                <div className="row g-3 mb-3">
                  {downloads.map((download) => {
                    return (
                      <DownloadCard
                        data={download}
                        key={download.id}
                      />
                    );
                  })}
                </div>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  pagination={paginationHandler}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </div >
  );
}
